import BootloaderScene from '../Bootloader';

export default class BaseScene extends Phaser.Scene {

    public width = 0;
    public height = 0;
    public gameWidth = 0;
    public gameHeight = 0;
    public screenWidth = 0;
    public screenHeight = 0;
    public gameGuideHeight = 0;
    public gameGuideWidth = 0;
    public resizeFactorY = 0;
    public sceneName: string;
    public bootloaderScene?: BootloaderScene;

    constructor(config: Phaser.Types.Scenes.SettingsConfig) {
        super(config);
        this.sceneName = config.key ?? '';
    }

    public getBootloaderScene(): BootloaderScene {
        if (!this.bootloaderScene) {
            throw new Error('Bootloader Scene is not defined');
        }
        
        return this.bootloaderScene;
    }

    public init(_data: any = null): void {
        // Init Scene
        console.log('Scene Init: ' + this.sceneName);

        this.width = this.game.config.width as number;
        this.height = this.game.config.height as number;
        this.screenWidth = this.scale.width;
        this.screenHeight = this.scale.height;
        this.gameGuideWidth = this.getGameGuideWidth();
        this.gameGuideHeight = this.getGameGuideHeight();
        this.resizeFactorY = this.getResizeFactorY();
        this.bootloaderScene = this.scene.get('Bootloader') as BootloaderScene;
        this.bootloaderScene.scenesRunning.push(this.sceneName);
    }

    private getGameGuideHeight(): number {
        if(this.screenWidth <= this.width - 13) {
            const heightResizedByScaleX = (this.height * this.screenWidth) / this.width;
            if(this.screenHeight <= heightResizedByScaleX) {
                return this.screenHeight;
            }
            return heightResizedByScaleX;
        }
        return this.screenHeight;
    }

    private getGameGuideWidth(): number {
        if(this.screenHeight <= this.height - 13) {
            const widthResizedByScaleY = (this.width * this.screenHeight) / this.height;
            if(this.screenWidth <= widthResizedByScaleY) {
                return this.screenWidth;
            }
            return widthResizedByScaleY;
        }
        return this.screenWidth;
    }

    private getResizeFactorY(): number {
        if(this.screenWidth > this.width - 13) {
            return 1;
        }
        return this.gameGuideHeight/this.height;
    }

    public create() {
        // Config Scene
        this.bootloaderScene?.updateResize(this);  
        if (this.bootloaderScene?.globals.debugMode) {
            const img = this.add.image(0, 0, 'guide').setOrigin(0).setDepth(1);
            this.setImmobileSprite(img);
        }     
    }

    public setImmobileSprite(sprite: any) {
        sprite.setScrollFactor(0);
        if (sprite instanceof Phaser.GameObjects.Container) {
            sprite.each(function(child: any) {
                child.setScrollFactor(0);
            });
        }
        sprite.setX((sprite.x) + this.screenWidth / 2 - (this.width / 2));
        sprite.setY((sprite.y) + this.screenHeight / 2 - (this.height / 2));
    }

    public forceSpriteNotScaleY(sprite: Phaser.GameObjects.Sprite | Phaser.GameObjects.Image) {
        sprite.setScale(1/this.resizeFactorY);
    }

    public forceSpriteTopPosition(sprite: Phaser.GameObjects.Sprite) {
        sprite.setY(this.forceTopPositionY(sprite.y));
    }

    private forceTopPositionY(y: number, padding = 0): number {
        const topAvailableSpace = (this.screenHeight - this.gameGuideHeight) / 2;
        const newY = y + (padding/this.resizeFactorY) - (topAvailableSpace/this.resizeFactorY);
        return newY;
    }

    public forceSpriteBottomPosition(
        sprite: Phaser.GameObjects.Sprite | Phaser.GameObjects.Container | Phaser.GameObjects.Text,
        padding: number
    ) {
        sprite.setY(this.forceBottomPositionY(sprite.y, padding));
    }

    public forceBottomPositionY(y: number, padding = 0): number {
        const topAvailableSpace = (this.screenHeight - this.gameGuideHeight) / 2;   
        const newY = y - (padding/this.resizeFactorY) + (topAvailableSpace/this.resizeFactorY);
        return newY;
    }
    
    public cleanUp() {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
    }

    public restart() {
        this.scene.restart();
    }
}